export function currentRoute(state, data) {
  state.currentRoute = data;
}